import { ObjectLike } from '@/types/objectlike.types';

const GAMERTAG_MAXLENGTH = 15;

export default function useProfileEditRules(
  formRules: ObjectLike,
  signupTexts: ObjectLike,
) {
  const {
    required,
    maxLength,
    fileSize,
  } = formRules;

  const {
    gamertagLabel,
    profilePicLabel,
    profileCoverLabel,
  } = signupTexts;

  const gamertagRules = [
    ...required(gamertagLabel),
    ...maxLength(gamertagLabel, GAMERTAG_MAXLENGTH),
  ];

  const profilePicRules = [
    ...fileSize(profilePicLabel),
  ];
  const profileCoverRules = [
    ...fileSize(profileCoverLabel),
  ];

  return {
    gamertagRules,
    profilePicRules,
    profileCoverRules,
  };
}
